import { render, staticRenderFns } from "./gif.vue?vue&type=template&id=898747da&scoped=true&"
var script = {}
import style0 from "./gif.vue?vue&type=style&index=0&id=898747da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898747da",
  null
  
)

export default component.exports